<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cell-db-click="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <btn-confirm
            title="确定要启用选中数据吗?"
            :ready="setOpenReady"
            @confirm="setOpen"
        >
          <vxe-button>启用</vxe-button>
        </btn-confirm>
      </template>
    </x-grid>


    <!--明细页表单简化通用写法-->
    <formModal title="自动欢迎语" :visible="editModalVisible">
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </formModal>
  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
  fmt
} from "@/utils/common/XGridBase"

import detailForm from "./AutoReplySetUpDetail";
import {dataApi} from "@/services/operate/AutoReplySetUp";

//列表接口
const url = api.operate.SEND_WELCOME_MSG;

//主键
const rowId = 'messageId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("content", "欢迎语", 160),
  fac.makeColumn("createDate", "配置时间", 300),
  fac.makeColumn("isUse", "是否启用", 120, 'center', true, fmt.formatYesNo),
  fac.makeColumn("createUserName", "创建人", 160),
  fac.makeColumn("createDate", "创建时间", 160),
  fac.makeColumn("lastModifyUserName", "最后修改人", 160),
  fac.makeColumn("lastModifyDate", "最后修改时间", 160),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'content'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: true,
  addData: true,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  components: {
    detailForm,
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
  },
  methods: {
    loadBaseData,
    /**
     * ready 需要返回布尔
     */
    setOpenReady() {
      let row = this.getRows();
      if (row.length !== 1) {
        this.$message.error('请选择一条数据');
        return false;
      }
      if (row[0].isUse) {
        this.$message.error('该数据已启用');
        return false;
      }
      return true;
    },
    async setOpen() {
      let row = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      this.loading(true);
      await dataApi.updateIsUse(row[0][this.rowId]).then(() => {
        this.$message.success('启用成功');
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
      this.refresh()
    }
  }
}
</script>

<style scoped>
</style>